<!--
 * @Author: wangjiaxiang
 * @Date: 2022-06-08 10:07:35
 * @LastEditTime: 2022-10-14 09:07:52
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /大增长星妈会C端/xmh-front-content/src/views/contents/foodColumn/foodDetail.vue
 *
-->
<template>
  <div class="wrapper">
    <!-- 返回（小程序来源时隐藏） -->
    <go-back v-if="!checkFromMiniprogram" style="z-index:99999;" @goBack="goBackHandle"></go-back>
    <span v-if="!checkFromMiniprogram" class="gobackBtn" style="z-index:99999;" @click="goBackHandle">
      <img alt src="@/assets/images/icon/back1.png"/>
    </span>
    <!-- 顶部视频 -->
    <div
        v-lazy:background-image="videoDetail.imgUrl"
        :style="{ height: headerHeight + 'px' }"
        class="header"
    >
      <HFVideo
          v-show="showVideo"
          ref="childVideo"
          :goods="goods"
          :userInfo="userInfo"
          :videoDetail="videoDetail"
          class="hfvideoclass"
          @nextVideo="nextVideo"
      ></HFVideo>
      <!-- <img
        class="play-icon"
        src="../../../assets/images/icon/off.png"
        @click="playerVideo"
        alt
      /> -->
    </div>
    <!-- 标题专题区域 -->
    <div class="title-project">
      <!-- 视频标题和点赞收藏等功能 -->
      <div class="headlines-and-likes">
        <!-- 标题 -->
        <p class="videoTitle">
          {{ videoDetail.recipeName }}
        </p>
        <!-- 点赞收藏等功能 -->
        <div class="likes">
          <p>
            <span>自制</span>&nbsp;·&nbsp;视频 &nbsp;·<span
          >&nbsp;{{ fomatterNum(videoDetail.playNum) }}播放</span
          >
          </p>
          <div class="common" v-if="!checkFromMiniprogram">
            <p>
              <img
                  :src="
                  videoDetail.orLike
                    ? require('@assets/images/food/like_icon3.png')
                    : require('@assets/images/food/like_icon.png')
                "
                  alt=""
                  @click="videoDetail.orLike ? videoCanceLike() : videoLike()"
              />
              <span>{{ fomatterNum(videoDetail.likeNum) }}</span>
            </p>
            <p>
              <img
                  :src="
                  videoDetail.orFavorites
                    ? require('@assets/images/food/collect_icon3.png')
                    : require('@assets/images/food/collect_icon.png')
                "
                  alt=""
                  @click="
                  videoDetail.orFavorites
                    ? videoCancelCollection()
                    : videoCollection()
                "
              />
              <span>{{ fomatterNum(videoDetail.collectNum) }}</span>
            </p>
            <p v-if="commentTotal">
              <img
                  alt=""
                  src="@assets/images/food/message_icon.png"
                  @click="toScroll"
              />
              <span>{{  fomatterNum(commentTotal) }}</span>
            </p>
            <p>
              <img
                  alt=""
                  src="@assets/images/food/share_icon.png"
                  @click="shareTap"
              />
              <span>{{ fomatterNum(videoDetail.shareNum) }}</span>
            </p>
          </div>
        </div>
      </div>

      <!-- 食材推荐（小程序来源时隐藏） -->
      <div v-if="!checkFromMiniprogram && videoDetail.goods" class="food-recommended">
        <div class="title">食材推荐</div>
        <div class="project-content-food">
          <div class="swiper">
            <div
                v-for="(item, index) in videoDetail.goods"
                :key="index"
                :data="JSON.stringify(item)"
                class="swiper-slide goods-view"
            >
              <div
                  class="tagWrap"
                  @click.stop="
                  toProductDetails(item),
                    goToMini('shicai' + item.goodsId, item.jumpUrl)
                "
              >
                <openWxTag
                    :id="'xmyxItem' + item.productId"
                    :name="item.productName"
                    :path="
                    '/subPackages/shopMainProcess/product/index?productId=' +
                      item.productId +
                      '&skuId=' +
                      item.goodsId +
                      '&actionLinkCode=10013'
                  "
                    btnStyle="width: 100%; height: 181px; display: block;"
                    @sensorsFn="sensorsFn"
                >
                </openWxTag>
              </div>
              <div class="image">
                <img v-lazy="item.pic" alt=""/>
              </div>
              <p>{{ item.productName }}</p>
              <div v-if="item.sales_price.promotion_type == 6" class="shop-txt">
                {{ item.sales_price.point_value }}积分
              </div>
              <div
                  v-else-if="
                  item.sales_price.promotion_type == 8 &&
                    item.sales_price.flag == 1
                "
                  class="shop-txt"
              >
                {{ item.sales_price.point_value }}积分/￥{{
                  item.sales_price.value
                }}
              </div>
              <div
                  v-else-if="
                  item.sales_price.promotion_type == 8 &&
                    item.sales_price.flag == 0
                "
                  class="shop-txt"
              >
                {{ item.sales_price.point_value }}积分+￥{{
                  item.sales_price.value
                }}
              </div>
              <div
                  v-else-if="item.sales_price.promotion_type == 7"
                  class="shop-txt"
              >
                ￥{{ item.value }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容简介 -->
      <contentIntroduction :videoDetail="videoDetail"/>
      <!-- 相关视频推荐 -->
      <div v-show="projectListContent.length > 1" class="specail-content-bg">
        <div class="specail-title">
          相关视频推荐
        </div>
        <div class="project-content">
          <div class="swiper">
            <div
                v-for="(item, index) in projectListContent"
                v-show="item.id !== activeSonId"
                :key="index"
                :class="['swiper-slide', 'slide-view', 'off' + item.id]"
                :data="JSON.stringify({ item: item })"
                @click="switchVideo(item)"
            >
              <div v-lazy:background-image="item.imgUrl"></div>
              <div class="text">
                {{ item.recipeName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 评论（小程序来源时隐藏） -->
    <div v-if="!checkFromMiniprogram" class="comments">
      <comment-field
          ref="focus"
          :Info="videoDetail"
          :articalId="videoDetail.id"
          :carrierId="carrierId"
          :commentTotal="10"
          :currentTop="100"
          :foodSendImg="foodInitImg"
          :isFoodDetail="1"
          :isGoLogin="isGoLogin"
          :title="videoDetail.recipeName"
          @clearPic="clearcommentPic"
          @focusOn="getFocusOn"
          @sendPiclen="getPiclen"
          @sendUpload="getUpimg"
          @type="getType"
      ></comment-field>
      <all-comment
          ref="allComment"
          :articalId="videoDetail.id"
          :carrierId="carrierId"
          :isGoLogin="isGoLogin"
          :title="videoDetail.recipeName"
          @comTotal="comTotal"
          @focusOn="getFocusOn"
          @type="getType"
      ></all-comment>
    </div>
    <!-- 分享（小程序来源时隐藏） -->
    <share-wx v-if="!checkFromMiniprogram" ref="sharEntry"></share-wx>
    <!-- 全部专题展开隐藏 -->
    <allProjects
        :activeSonId="activeSonId"
        :data="projectListContent"
        :popupHeight="popupHeight"
        :popupShow="popupShow"
        @switchVideo="switchVideo"
    />
  </div>
</template>
<script
    src="https://res.wx.qq.com/open/js/jweixin-1.2.0.js"
    type="text/javascript"
></script>
<script>
// 组件
import HFVideo from './component/video.vue' //视频组件
import commentField from './component/commentField' //评论
import allComment from './component/allcomment' //评论
import goBack from '@/components/common/goBack' //返回组件
import shareWx from '@/components/comment/share' //辅食微信指导弹框
import openWxTag from '@/components/common/openWeappTag/index.vue' // 打开小程序开放标签
import allProjects from './component/allProjects.vue' // 全部专题组件
import contentIntroduction from './component/contentIntroduction.vue' //内容描述组件
// 方法
import wxJsSet from "@/assets/js/profileConfig"; //微信多张上传图片
import * as until from "@/assets/js/common.js"; //公共方法
import {goToMini, isFromMiniprogram} from "@/assets/js/common.js"; //公共方法
import {nutritionKitchen_content, nutritionKitchen_goods,} from "@/assets/js/Exposure";
import {BuiedPointClick_Fn} from "@/assets/js/BuriedPointEvent";
import { commonAddCollect } from '@/utils/commonApiList'


export default {
  name: '',
  props: [''],
  data() {
    return {
      popupHeight: 300, //全部专题的高
      popupShow: false, //全部专题显示隐藏
      showVideo: false, //显示视频组件
      videoDetail: {}, //视频详情数据
      allArojectStatus: false, //控制全部专题显示隐藏
      commentTotal: '', //评论总数
      foodInitImg: [], //图片数组
      carrierId: '7', //辅食id
      userInfo: JSON.parse(localStorage.getItem('userInfo')), //用户信息
      checkLogin: false, //登陆弹窗状态
      state: false, //视频状态 全屏还是样式全屏
      projectDataList: [], //专题数据
      classificationList: [], //分类标题数据
      projectListContent: [], //当前专题下数据
      activeId: null, //当前分类选中
      activeSonId: this.$route.params.id, // 当前分类下视频选中
      dataInfo: {}, //辅食详情
      headerHeight: 0, //动态视频高度
      goods: '', //商品名称
    }
  },

  components: {
    HFVideo,
    commentField,
    allComment,
    goBack,
    shareWx,
    openWxTag,
    allProjects,
    contentIntroduction,
  },

  computed: {
    isGoLogin() {
      return until.isUserLogin()
    },
    // 判断当前页面是否来自星妈会小程序，用于控制部分模块在小程序内隐藏
    checkFromMiniprogram() {
      return isFromMiniprogram(this.$route);
    },
  },
  watch: {
    projectListContent: {
      handler(newValue) {
        this.projectListContent = newValue
        console.log(newValue, 'newValue')
      },
      deep: true
    }
  },
  created() {
    this.initPage()
  },
  mounted() {
    let self = this
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        console.log('hidden')
        self.$refs.childVideo.Player.pause()
      } else {
        self.$refs.childVideo.Player.play()
        // 此处填写H5监听到关闭小程序的操作，比如wx.closeWindow();
        console.log('监听到关闭小程序')
      }
    })
    this.init()
    this.$nextTick(() => {
      document.addEventListener(
          'WeixinJSBridgeReady',
          function () {
            setTimeout(() => {
              document.getElementsByTagName('video')[0].play()
            }, 500)
          },
          false
      )
    })
  },
  methods: {
    goToMini,
    init() {
      this.$http.get(
          '/wechat/oauth2/getJSSDKConfig?url=' +
          encodeURIComponent(location.href.split('#')[0]),
          {},
          (res) => {
            wx.config({
              debug: false,
              appId: res.appId,
              timestamp: res.timestamp,
              nonceStr: res.nonceStr,
              signature: res.signature,
              jsApiList: ['onMenuShareTimeline'], // 必填，需要使用的JS接口列表
              openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
            })
            wx.ready(function () {
              console.log('ready')
            })
            wx.error(function (res) {
              console.log('err', res)
            })
          }
      )
    },
    // 初始化页面
    initPage() {
      this.getVideoDetail(this.$route.params.id) //获取视频详情
    },
    playerVideo() {
      this.showVideo = true
      this.$refs.childVideo.initPlayer()
      $('.header').attr('style', 'background:none') //去掉封面图
      // $(".play-icon").attr("style", "display:none"); //去掉播放按钮
    },
    // 控制全部专题显示隐藏
    projectStatusControl() {
      $(window).scrollTop(0)
      this.popupHeight =
          $(window).height() -
          $('.header').height() -
          $('.project-title').height()

      this.popupShow = !this.popupShow
      // this.allArojectStatus = !this.allArojectStatus;
      if (this.popupShow) {
        $('.white-layer i').addClass('rotate')
        $('.project-title-bg').addClass('project-title-fixed')
        $('.project-title-bg').css('top', $('.header').height())
        // 查看全部专题埋点
        sensors.track('xmhH5yycf_videodetail_click', {
          food_video_name: this.videoDetail.recipeName,
          video_label: this.videoDetail.recipeTag,
          yycf_zhuanti_name: this.videoDetail.project,
          op_zhuanti: '查看全部专题',
          yycf_product_name: this.goods,
        })
      } else {
        $('.white-layer i').removeClass('rotate')
        $('.project-title-bg').removeClass('project-title-fixed')
        $('.project-title-bg').css('top', 0)
      }
    },
    // 清除图片数组
    clearcommentPic() {
      this.total = this.len
      this.foodInitImg = []
    },
    comTotal(val) {
      this.commentTotal = val
    },
    getUpimg(fileList, callback) {
      console.log(fileList,'00000000000000000000000000000000000')
      if (fileList.length != 0) {
        var length = fileList.length
        var formdata = new FormData()
        formdata.append('files', fileList)
        try {
          this.$http.post(
              '/upload/batchPictureFile',
              {ContentType: 'application/x-www-form-urlencoded'},
              formdata,
              (res) => {
                if (res.code === '200') {
                  this.foodInitImg = this.foodInitImg.concat(res.data)
                  this.total = this.len - this.foodInitImg.length
                  callback()
                } else if (res.code === '500') {
                  this.foodInitImg = []
                  this.$toast({
                    message: '服务器异常，程序猿小哥哥正在努力修复~',
                    duration: 2000,
                  })
                } else {
                  this.foodInitImg = []
                  this.$toast({
                    message: res.message,
                    duration: 2000,
                  })
                }
              }
          )
        } catch (err) {
          this.foodInitImg = []
          if (err.code === '500') {
            this.$toast({
              message: '服务器异常，程序猿小哥哥正在努力修复~',
              duration: 2000,
            })
          } else {
            this.$toast({
              message: err.message,
              duration: 2000,
            })
          }
        }
      }
    },
    //调取微信上传
    getUpload() {
      let that = this
      wxJsSet.getMoreAlbum(this, this.total, function (res) {
        that.uploadFoodImg(res)
      })
    },
    uploadFoodImg(data) {
      API.uploadImages({mediaId: data[0]}, {}, (res) => {
        if (res.code === '200') {
          this.foodInitImg.push(res.data)
          this.total = this.len - this.foodInitImg.length
        }
      })
    },
    /**
     * @description:
     * @param {*} num 图片数量
     * @return {*}
     */

    getPiclen(num) {
      this.total = this.len - num
    },
    /**
     * @description:
     * @param {*} bool Boolean
     * @return {*}
     */

    getFocusOn(bool) {
      this.$refs.focus.isFocus = bool
    },
    /**
     * @description:
     * @param {*} type string
     * @return {*}
     */

    getType(type) {
      this.$refs.focus.type = type
    },
    // 返回
    goBackHandle: until.Debounce(function () {
      console.log('goBackHandle0-------------------')
      if (this.$refs.childVideo.videorequestCssFullscreen) {
        this.$refs.childVideo.Player.exitCssFullscreen()
      } else {
        if (this.$refs.childVideo.Player) {
          let time = Math.floor(this.$refs.childVideo.Player.currentTime)
          // 后续在优化
          if (time <= 10) {
            this.videoDetail.quitplaytimeStr = '0-10秒'
          } else if (time <= 20) {
            this.videoDetail.quitplaytimeStr = '11-20秒'
          } else if (time <= 30) {
            this.videoDetail.quitplaytimeStr = '21-30秒'
          } else if (time <= 40) {
            this.videoDetail.quitplaytimeStr = '31-40秒'
          } else if (time <= 50) {
            this.videoDetail.quitplaytimeStr = '41-50秒'
          } else if (time <= 60) {
            this.videoDetail.quitplaytimeStr = '51-60秒'
          } else if (time <= 120) {
            this.videoDetail.quitplaytimeStr = '61-120秒'
          } else if (time > 120) {
            this.videoDetail.quitplaytimeStr = '121秒以上'
          }
          BuiedPointClick_Fn("xmhH5yycf_videodetail_quitplay", {
            food_video_name: this.videoDetail.recipeName,
            video_label: this.videoDetail.recipeTag,
            video_time: this.videoDetail.videoDuration,
            quitplay_time: Math.floor(this.$refs.childVideo.Player.currentTime),
            yycf_zhuanti_name: this.videoDetail.project,
            xmhH5yycf_quitplaytime: this.videoDetail.quitplaytimeStr,
          })
        }
        setTimeout(() => {
          if (window.history.length > 1 && until.getCookie("fromPath")) {
            this.$router.go(-1);
          } else {
            this.$router.replace("/foodColumn");
          }
        }, 200);
      }
    }),
    //获取视频详情
    getVideoDetail(id, status) {
      this.videoDetail = {}
      this.$http.post(
          '/recipeFoodBanner/getAudioById',{},
          {id: id, crmId: this.userInfo ? this.userInfo.crm_id : '',topicId:this.$route.query.topId},
          (res) => {
           console.log();
            if (res.code === 200) {
              if (
                  this.$refs.childVideo.Player &&
                  this.$refs.childVideo.Player.fullscreen
              ) {
                if (!res.data.plateType) {
                  status = 'noNext'
                } else {
                  // 当前视频为竖屏 上一首为横屏并且横屏是全屏显示 让用户退出全屏
                  this.$refs.childVideo.exitScreen()
                  status = 'next'
                }
              }
              this.videoDetail = res.data
              // 详情获取成功埋点
              if (this.videoDetail.goods) {
                for (var i = 0; i < this.videoDetail.goods.length; i++) {
                  this.goods +=
                      this.videoDetail.goods[i].productName +
                      (i == this.videoDetail.goods.length - 1 ? '' : ',')
                }
              } else {
                this.goods = ''
              }
              // 判断横版竖版视频 1竖版 0横版
              this.activeSonId = this.videoDetail.id
              // 首次进入获取一次专题列表
              if (!this.activeId) {
                this.projectList() //获取专题列表
              } else {
                for (var i = 0; i < this.projectDataList.length; i++) {
                  // 通过id匹配数据 获取专题名称
                  if (this.activeId == this.projectDataList[i].id) {
                    this.videoDetail.project = this.projectDataList[i].name
                  }
                }
                sensors.track('xmhH5yycf_videodetail_view', {
                  food_video_name: this.videoDetail.recipeName,
                  video_label: this.videoDetail.recipeTag,
                  yycf_zhuanti_name: this.videoDetail.project,
                  yycf_product_name: this.goods,
                })
              }

              // this.activeId = this.videoDetail.topicId;
              // $(".header").attr("style", "background:block"); //显示封面图
              // this.videoDetail.goods[0].pic = this.videoDetail.goods[0].pic.replace(/\.[^.]+$/, '.jpg');
              const {isAndroid} = until.TestUserAgent()
              this.videoDetail.isAndroid = isAndroid
              this.$nextTick(() => {
                if (res.data.plateType) {
                  $('.header').addClass('videoHeight')
                  $('.childVideo').addClass('videoHeight')
                } else {
                  setTimeout(() => {
                    $('video').css('object-fit', 'cover') // 解决苹果12 11 视频两边虚化
                  })
                  $('.header').removeClass('videoHeight')
                  $('.childVideo').removeClass('videoHeight')
                }
                if (status == 'next') {
                  // this.$refs.childVideo.clear();
                }
                if (this.popupShow) {
                  this.$nextTick(() => {
                    $(window).scrollTop(0)
                    this.popupHeight =
                        $(window).height() -
                        $('.header').height() -
                        $('.project-title').height()
                    $('.project-title-bg').css('top', $('.header').height())
                  })
                }
                this.playerVideo()
              })
              var shareDataParams = {
                shareLink: location.href.split('#')[0],
                shareDesc: '选新鲜的食材，做营养的料理，轻松带娃，精致当妈！',
                shareTitle: this.videoDetail.recipeName,
                imgUrl: 'https://image-mom.feihe.com/wxshare/foodShare.jpg', //必须是绝对路径
                shareFlag: true,
                shareType: 'food',
                shareid: id,
              }
              this.wxJsSet.wxShare('fx', shareDataParams, this)
              // 商品曝光
              setTimeout(() => {
                nutritionKitchen_goods.observe('.goods-view', false, {
                  videoName: this.videoDetail.recipeName,
                })
              }, 300)
            }
          },
          (err)=>{},"lucky"
      )
    },
    // 获取专题列表-详情
    projectList() {
      this.$http.get('/recipeFoodBanner/findDetailTopicList', {}, (res) => {
        if (res.code === 200) {
          // console.log(res,'this.$route.query.topId');
          // ios获取跳转链接参数
          const url = location.search.split('?')[1]
          console.log(url, 'query')
          this.activeId =Number(this.$route.query.topId) || Number(url.split('=')[1]) || this.videoDetail.topicId
          this.projectDataList = res.data
          console.log('this.activeId', this.activeId)
          console.log('this.activeId2', this.videoDetail)
          for (var i = 0; i < this.projectDataList.length; i++) {
            // this.classificationList.push({
            //   id: this.projectDataList[i].id,
            //   name: this.projectDataList[i].name,
            // });
            console.log(this.activeId == this.projectDataList[i].id, 'wwwww')
            // 通过id匹配数据 首次进来定位到当下分类
            if (this.activeId == this.projectDataList[i].id) {
              this.projectListContent = this.projectDataList[i].audioList
              console.log(this.projectListContent, 'projectListContent')
              this.videoDetail.project = this.projectDataList[i].name
            }
          }
          // 计算滚动距离
          this.$nextTick(() => {
            $('.project-content .swiper').scrollLeft(
                $(`.off${this.activeSonId}`).offset().left - 12
            )
          })
          // 神策曝光埋点
          setTimeout(() => {
            nutritionKitchen_content.observe('.slide-view', false, {
              project: this.classificationList.filter((item) => {
                if (item.id == this.activeId) {
                  return item.name
                }
              }),
            })
            nutritionKitchen_goods.observe('.goods-view', false, {
              videoName: this.videoDetail.recipeName,
            })
            sensors.track('xmhH5yycf_videodetail_view', {
              food_video_name: this.videoDetail.recipeName,
              video_label: this.videoDetail.recipeTag,
              yycf_zhuanti_name: this.videoDetail.project,
              yycf_product_name: this.goods,
            })
          }, 300)
        }
      },(err)=>{},'lucky')
    },
    // 专题分类点击
    tabClick(id, tittle) {
      this.activeId = id
      // 通过id匹配数据
      for (var i = 0; i < this.projectDataList.length; i++) {
        if (id == this.projectDataList[i].id) {
          this.projectListContent = this.projectDataList[i].audioList
        }
      }
      console.log(this.videoDetail)
      // 切换专题埋点
      sensors.track('xmhH5yycf_videodetail_click', {
        food_video_name: this.videoDetail.recipeName,
        video_label: this.videoDetail.recipeTag,
        yycf_zhuanti_name: this.videoDetail.project,
        op_zhuanti: '切换专题',
        yycf_product_name: this.goods,
      })
      // 神策曝光埋点
      setTimeout(() => {
        nutritionKitchen_content.observe('.slide-view', false, {
          project: this.classificationList.filter((item) => {
            if (item.id == this.activeId) {
              return item.name
            }
          }),
        })
      }, 300)
    },
    // 视频点赞
    videoLike: until.Debounce(function () {
      if (this.isGoLogin) {
        until.globalGoLogin()
        return
      }
      this.$http.get(
          '/recipeFoodBanner/addLike',
          {crmId: this.userInfo.crm_id, id: this.videoDetail.id},
          (res) => {
            if (res.code === 200) {
              var relation = 'fooddianzan' + this.videoDetail.id
              console.log(this.videoDetail.id,'this.videoDetail.id');
              this.videoDetail.orLike = !this.videoDetail.orLike
              this.videoDetail.likeNum = this.videoDetail.likeNum + 1
              this.$toast({
                duration: 2000,
                message: this.taskTip()['1'],
                context: this,
              })
              // 点赞埋点
              sensors.track('xmhH5yycf_videodetail_click', {
                food_video_name: this.videoDetail.recipeName,
                video_label: this.videoDetail.recipeTag,
                yycf_zhuanti_name: this.videoDetail.project,
                op_zhuanti: '点赞',
                yycf_product_name: this.goods,
              })
            }
          },
          (err)=>{},
          "lucky"
      )
    }, 300),
    // 视频取消点赞
    videoCanceLike: until.Debounce(function () {
      this.$http.get(
          '/recipeFoodBanner/cancelLike',
          {crmId: this.userInfo.crm_id, id: this.videoDetail.id},
          (res) => {
            if (res.code === 200) {
              this.videoDetail.orLike = !this.videoDetail.orLike
              this.videoDetail.likeNum = this.videoDetail.likeNum - 1
            }
          },
          (err)=>{},"lucky"
      )
    }, 300),
    // 视频收藏
    videoCollection: until.Debounce(function () {
      if (this.isGoLogin) {
        until.globalGoLogin()
        return
      }
      commonAddCollect({crmId: this.userInfo.crm_id, id: this.videoDetail.id}).then((res) => {
        if (res.code === 200) {
          this.videoDetail.orFavorites = !this.videoDetail.orFavorites
          this.videoDetail.collectNum = this.videoDetail.collectNum + 1
          var relation = 'foodsc_' + this.videoDetail.id
          this.$toast({
                duration: 2000,
                message: this.taskTip()['2'],
                context: this,
              })
          // 收藏埋点
          sensors.track('xmhH5yycf_videodetail_click', {
            food_video_name: this.videoDetail.recipeName,
            video_label: this.videoDetail.recipeTag,
            yycf_zhuanti_name: this.videoDetail.project,
            op_zhuanti: '收藏',
            yycf_product_name: this.goods,
          })
        }
      })
    }, 300),
    // 视频取消收藏
    videoCancelCollection: until.Debounce(function () {
      this.$http.get(
          '/recipeFoodBanner/cancelCollect',
          {crmId: this.userInfo.crm_id, id: this.videoDetail.id},
          (res) => {
            if (res.code === 200) {
              this.videoDetail.orFavorites = !this.videoDetail.orFavorites
              this.videoDetail.collectNum = this.videoDetail.collectNum - 1
            }
          },
          (err)=>{},'lucky'
      )
    }, 300),
    // 完成任务
    taskTip() {
      return {
        1: '点赞成功',
        2: '收藏成功',
        3: '分享成功',
        4: '评论成功',
      }
    },
    // 滚动到评论
    toScroll() {
      $('html,body').animate(
          {
            scrollTop: $('.commentWrap').offset().top,
          },
          1000
      )
      // 切换专题埋点
      sensors.track('xmhH5yycf_videodetail_click', {
        food_video_name: this.videoDetail.recipeName,
        video_label: this.videoDetail.recipeTag,
        yycf_zhuanti_name: this.videoDetail.project,
        op_zhuanti: '评论',
        yycf_product_name: this.goods,
      })
    },
    // 手动切换视频
    switchVideo(item) {
      console.log(item)
      this.getVideoDetail(item.id)
      sensors.track('xmhH5yycf_videolist_click', {
        food_video_name: item.recipeName,
        video_label: item.recipeTag,
        yycf_zhuanti_name: this.videoDetail.project,
        video_click_location: '营养厨房详情页',
      })
    },
    // 自动下一个视频
    nextVideo(id) {
      for (var i = 0; i < this.projectListContent.length; i++) {
        if (id == this.projectListContent[i].id) {
          if (i == this.projectListContent.length - 1) {
            // this.getVideoDetail(this.projectListContent[0].id);
            // this.videoDetail = this.projectListContent[0]
          } else {
            this.getVideoDetail(this.projectListContent[i + 1].id, 'next')
            // this.videoDetail = this.projectListContent[i + 1];
            // 判断横版竖版视频 1竖版 0横版
            if (this.videoDetail.plateType) {
              $('.header').addClass('videoHeight')
              $('.childVideo').addClass('videoHeight')
            } else {
              $('.header').removeClass('videoHeight')
              $('.childVideo').removeClass('videoHeight')
            }
          }
          $('.xgplayer-replay-txt').text('重新播放')
          // 切换专题埋点
          sensors.track('xmhH5yycf_videodetail_click', {
            food_video_name: this.videoDetail.recipeName,
            video_label: this.videoDetail.recipeTag,
            yycf_zhuanti_name: this.videoDetail.project,
            op_zhuanti: '切换视频',
            yycf_product_name: this.goods,
          })
        }
      }
    },
    // 分享
    shareTap() {
      this.$refs.sharEntry.showShareVideo() //显示分享蒙层组件
      // 当前视频分享+1
      this.$http.get(
          '/recipeFoodBanner/addShare',
          {id: this.videoDetail.id},
          (res) => {
            if (res.code == 200) {
              console.log(res)
              this.videoDetail.shareNum = this.videoDetail.shareNum + 1
              // 分享埋点
              sensors.track('xmhH5yycf_videodetail_click', {
                food_video_name: this.videoDetail.recipeName,
                video_label: this.videoDetail.recipeTag,
                yycf_zhuanti_name: this.videoDetail.project,
                op_zhuanti: '分享',
                yycf_product_name: this.goods,
              })
            }
          },
          (err)=>{},
          "lucky"
      )
    },
    // 格式化数字
    fomatterNum(num) {
      if (num) {
        var num = (num || 0).toString(),
            result = ''
        if (num.length > 4) {
          var h = num.substring(num.length - 4, num.length - 3)
          result =
              num.substring(0, num.length - 4) +
              (h === '0' ? '' : '.') +
              (h === '0' ? '' : h) +
              '万'
          return result
        }
        return num
      } else {
        return 0
      }
    },
    toProductDetails(item) {
      console.log(item.productName)
      this.$refs.childVideo.Player.pause()
    },
    // 点击跳转商品页点击事件
    sensorsFn(name) {
      sensors.track('xmhh5_yycf_goods_click', {
        xmhh5_yycf_goodsname: name,
        food_video_name: this.videoDetail.recipeName,
      })
    },
  },
}
</script>
<style lang="less" scoped>
//返回按钮
/deep/ .gobackBtn2 {
  z-index: 10000;
}

// 全部专题展开 定位头部
.project-title-fixed {
  position: fixed !important;
  // top: 0px !important;
  z-index: 999;
}

// 返回按钮
.gobackBtn {
  z-index: 99;
  width: 26px;
  position: absolute;
  top: 7px;
  left: 10px;

  img {
    width: 100%;
    height: 100%;
  }
}

.wrapper {
  background: #f7f7f7;
}

.videoHeight {
  height: calc(100vh * 0.6);
}

// 顶部视频
.header {
  width: 100%;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  min-height: 202px;
  text-align: -webkit-center;
  position: relative;

  .play-icon {
    width: 48px;
    height: 48px;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);
  }
}

// 标题专题区域
.title-project {
  width: 100%;
  height: 100%;
  background: #ffffff;
  overflow: hidden;

  .headlines-and-likes {
    margin: 12px auto 0;
    width: 343px;
    // height: 107px;
    // background: red;
    border-bottom: 1px dashed #e6e2c9;
    // 标题
    .videoTitle {
      font-size: 17px;
      font-weight: 500;
      color: #333333;
    }

    // 点赞收藏等
    .likes {
      width: 100%;
      // height: 55px;
      padding-top: 4px;
      // background: green;
      p {
        font-size: 12px;
        color: #666666;

        span:nth-of-type(1) {
          color: #ff67c1;
        }
      }

      .common {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 18px 0 15px 0;

        p {
          display: flex;
          flex-direction: column;
          align-items: center;

          img {
            width: 24px;
            height: 24px;
            // margin-right: 3px;
          }

          span {
            font-size: 12px;
            transform: scale(0.83);
            color: #999999;
            display: inline-block;
          }
        }
      }
    }
  }

  .project-title-bg {
    width: 100%;
    position: relative;
    background: #ffffff;
    // 专题区域
    .project-title {
      width: 94%;
      height: 38px;
      overflow: hidden;

      /deep/ .van-tabs {
        .van-tab {
          font-size: 12px;
        }

        .van-tab--active {
          color: #e89f00;
        }
      }
    }

    .white-layer {
      width: 38px;
      height: 26px;
      position: absolute;
      top: 9px;
      right: 0px;
      background: url(../../../assets/images/food/white_layer.png);
      background-size: 100% 100%;
      line-height: 20px;

      .rotate {
        -moz-transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
      }

      span {
        float: left;
        margin-left: 14px;
        margin-top: 5px;

        /deep/ .van-icon {
          font-size: 9px;
          color: #666666;
        }
      }

      // img{
      //   width: 82px;
      //   height: 20px;
      // }
    }
  }

  // 专题内容
  .project-content {
    background-color: #fff;
    position: relative;
    padding-bottom: 12px;
    border-radius: 0 0 8px 8px;

    .swiper {
      padding-left: 12px;
      overflow-x: scroll;
      display: flex;
      overflow-y: hidden;

      .swiper-slide:last-child {
        padding-right: 12px;
      }

      .swiper-slide {
        width: 128px;
        padding-right: 9px;

        div:nth-child(1) {
          position: relative;
          width: 128px;
          height: 78px;
          display: block;
          border-radius: 8px;
          background-size: 100% 100%;

          div {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-radius: unset;
            position: absolute;
            width: 100%;
            bottom: 0;
            height: 18px;

            img {
              width: 59px;
              height: 18px;
            }
          }
        }

        .text {
          margin: 8px 0 0 4px;
          box-sizing: border-box;
          width: 120px;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 这里是超出几行省略 */
          overflow: hidden;
        }
      }

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}

.specail-content-bg {
  padding: 15px 16px 0;
  background-color: #f7f7f7;
}

.specail-title {
  background-color: #fff;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  padding: 12px 0 8px 12px;
  border-radius: 8px 8px 0 0;
}
.contentImg{
  width: 100%;
  height: 100%;
}

// 食材推荐
.food-recommended {
  width: 100%;
  padding-bottom: 16px;
  // height: 244px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;

  .title {
    // box-sizing: border-box;
    padding: 16px 16px 0;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    font-family: PingFangSC-Medium, PingFang SC;
  }

  // 食材推荐滑动
  .project-content-food {
    margin-top: 8px;
    position: relative;

    .swiper {
      box-sizing: border-box;
      padding: 0 12px;
      overflow-x: scroll;
      display: flex;
      overflow-y: hidden;

      .swiper-slide:last-child {
        // padding-right: 12px;
      }

      .swiper-slide {
        box-sizing: border-box;
        position: relative;
        margin-right: 12px;
        width: 120px;

        .tagWrap {
          width: 100%;
          height: 181px;
          position: absolute;
          top: -4px;
          right: 0;
          z-index: 99;
        }

        .image {
          box-sizing: border-box;
          border-radius: 8px;
          position: relative;
          width: 120px;
          height: 120px;
          border-radius: 7px;
          border: 1px solid #ededed;

          img {
            border-radius: 8px 8px 0 0;
            width: 100%;
            height: 100%;
          }
        }

        p {
          margin-top: 6px;
          padding-left: 6px;
          width: 120px;
        }

        p:nth-of-type(1) {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 这里是超出几行省略 */
          overflow: hidden;
        }

        .shop-txt {
          padding-left: 6px;
          margin-top: 6px;
          font-size: 12px;
          color: #ff6146;
        }
      }

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}

// 评论
.comments {
  margin: 8px auto 0;
  width: 343px;
  background: #ffffff;
  border-radius: 8px;

  /deep/ .commentWrap {
    border-radius: 8px;
  }

  // 评论输入框的宽
  /deep/ .commentWrap .van-search__content {
    width: 262px;
  }

  /deep/ .PublishComment {
    display: none;
  }
}
</style>
